import { CubeSideName } from "./components/Сube/types";
import { ModuleEnum } from "../../../constants";

export type CategoryNavItem = "organization" | "team" | "leadership";

export enum Category {
  Market = "market",
  Organization = "organization",
  Team = "team",
  Leadership = "leadership",
}

export enum CalculationType {
  Benchmark = "Benchmark",
  AverageScore = "AverageScore",
}

export enum MarketType {
  Type1 = "static-incremental",
  Type2 = "dynamic-incremental",
  Type3 = "static-disruptive",
  Type4 = "dynamic-disruptive",
}

export interface RouteParams {
  clientId: string;
  testId: string;
  module?: ModuleEnum;
  cubeSide?: CubeSideName;
  category?: CategoryNavItem;
}

export interface Point {
  x: number;
  y: number;
}

export type AiResponse = {
  summary: string;
  error?: { message?: string; code?: string };
};
